var _style, _g, _g2, _g3, _path, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdited2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-217.12,75c0,26.44-21.44,47.88-47.87,47.88c-26.45,0-47.88-21.44-47.88-47.88 c0-26.44,21.43-47.88,47.88-47.88C-238.56,27.12-217.12,48.56-217.12,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-217.94,62.81c15.58,3.21,25.3,7.99,25.3,13.33c0,9.67-32.39,17.5-72.36,17.5c-39.97,0-72.36-7.83-72.36-17.5 c0-5.46,8.94-10,25.13-13.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.34,328.72c0,40.44-32.77,73.2-73.2,73.2c-40.43,0-73.21-32.77-73.21-73.2c0-40.43,32.78-73.2,73.21-73.2 C290.57,255.52,323.34,288.29,323.34,328.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.34,328.72c0-24.04-11.58-45.38-29.48-58.72c-16.6,5.86-36.18,15.73-39.69,25.86 c-5.76,16.72,3.46,13.26,12.68,20.18c1.73,1.73,8.65,1.15,9.81,2.88c3.46,3.46-0.58,8.07,0,8.65c4.61,5.76,13.25,19.02,7.49,29.97 c-3.46,7.48-17.29,9.22-19.6,17.87c-1.77,7.98,4.34,15.65,12.27,21.47C304.05,386.22,323.34,359.74,323.34,328.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.66,312.95c9.08,3.61,22.74,1.17,27.68,10.59c4.04,8.07,10.37,21.9,12.69,30.56 c2.88,9.8-5.77,20.74,6.91,25.93c5.76-7.49,2.88-22.48,15.57-25.93c-2.89-23.06-40.35-25.95-9.81-44.97 c-13.83-7.68,6.44-32.65-7.04-49.03C201.58,268.66,184.02,288.52,178.66,312.95z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-23.54,75c0,39.46-31.99,71.46-71.46,71.46c-39.47,0-71.46-32-71.46-71.46c0-39.47,32-71.46,71.46-71.46 C-55.53,3.54-23.54,35.53-23.54,75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-107.92,64.9c0,7.7-6.24,13.93-13.93,13.93c-7.69,0-13.93-6.23-13.93-13.93c0-7.69,6.24-13.93,13.93-13.93 C-114.15,50.97-107.92,57.21-107.92,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-59.68,121.98c0,7.7-6.23,13.93-13.92,13.93c-7.7,0-13.94-6.24-13.94-13.93c0-7.7,6.24-13.92,13.94-13.92 C-65.91,108.05-59.68,114.28-59.68,121.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-67.83,89.36c0,5.07-4.11,9.18-9.17,9.18c-5.07,0-9.17-4.11-9.17-9.18c0-5.07,4.11-9.17,9.17-9.17 C-71.94,80.19-67.83,84.29-67.83,89.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-95.17,82.91c0,2.53-2.05,4.58-4.59,4.58c-2.53,0-4.58-2.05-4.58-4.58c0-2.53,2.05-4.59,4.58-4.59 C-97.22,78.32-95.17,80.37-95.17,82.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-143.65,61.61c0,3.29-2.66,5.95-5.95,5.95c-3.28,0-5.94-2.66-5.94-5.95c0-3.28,2.66-5.95,5.94-5.95 C-146.31,55.66-143.65,58.33-143.65,61.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-44.89,108.27c0,3.29-2.66,5.94-5.95,5.94c-3.28,0-5.95-2.66-5.95-5.94c0-3.29,2.67-5.95,5.95-5.95 C-47.55,102.32-44.89,104.99-44.89,108.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-125.58,105.33c0,4.88-3.95,8.84-8.83,8.84c-4.88,0-8.84-3.96-8.84-8.84c0-4.87,3.96-8.83,8.84-8.83 C-129.54,96.5-125.58,100.45-125.58,105.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-95.01,101.93c0,4.88-3.95,8.83-8.84,8.83c-4.87,0-8.83-3.94-8.83-8.83c0-4.88,3.96-8.83,8.83-8.83 C-98.96,93.1-95.01,97.05-95.01,101.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-103.84,128.43c0,2.62-2.12,4.75-4.75,4.75c-2.63,0-4.76-2.13-4.76-4.75c0-2.63,2.13-4.76,4.76-4.76 C-105.97,123.68-103.84,125.8-103.84,128.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-143.25,83.59c0,2.61-2.12,4.75-4.75,4.75c-2.63,0-4.76-2.14-4.76-4.75c0-2.63,2.12-4.76,4.76-4.76 C-145.38,78.83-143.25,80.96-143.25,83.59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    transform: "matrix(1.073029, 0, 0, 1.073914, -5.515922, -5.529118)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.14,75c0,39.29-31.85,71.14-71.15,71.14c-39.29,0-71.14-31.85-71.14-71.14C3.86,35.71,35.71,3.86,75,3.86 C114.29,3.86,146.14,35.71,146.14,75z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, 4)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.24,
    y1: 106.79,
    x2: 32.29,
    y2: 106.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.16,
    y1: 114.88,
    x2: 42.85,
    y2: 114.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.85,
    y1: 122.98,
    x2: 56.56,
    y2: 122.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 33.35,
    y1: 131.42,
    x2: 67.82,
    y2: 131.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.24,
    y1: 140.22,
    x2: 80.14,
    y2: 140.22
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.51,68.57c3.61-4.41,2.96-10.9-1.45-14.5L59.72,5.52c-7.84,1.71-15.19,4.71-21.83,8.78l68.12,55.72 C110.42,73.62,116.91,72.97,120.51,68.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.97,91.72c3.6-4.4,2.95-10.9-1.45-14.5L12.73,40.58c-3.49,6.3-6.06,13.2-7.51,20.49l39.23,32.1 C48.87,96.77,55.36,96.12,58.97,91.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.03,111.47c3.6-4.4,2.96-10.89-1.45-14.5L31.21,18.94c-5.45,4.27-10.26,9.31-14.27,14.96l96.57,79.01 C117.92,116.53,124.42,115.87,128.03,111.47z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.13,75.01c0,39.28-31.84,71.13-71.13,71.13c-39.29,0-71.14-31.85-71.14-71.13 c0-39.3,31.85-71.15,71.14-71.15C454.3,3.86,486.13,35.71,486.13,75.01z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 345.21,
    y1: 78.71,
    x2: 394.58,
    y2: 37.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 348.39,
    y1: 100.21,
    x2: 391.39,
    y2: 61.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 357.94,
    y1: 114.55,
    x2: 393.51,
    y2: 84.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 371.49,
    y1: 125.71,
    x2: 394.04,
    y2: 105.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 385.8,
    y1: 136.85,
    x2: 435.45,
    y2: 93.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 401.74,
    y1: 143.22,
    x2: 428.82,
    y2: 118.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 349.72,
    y1: 55.62,
    x2: 376.79,
    y2: 30.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 420.06,
    y1: 144.02,
    x2: 438.37,
    y2: 128.09
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdited2);
export default __webpack_public_path__ + "static/media/edited2.2bd2faa3cf6ea4b2684d3fdf3616e3fc.svg";
export { ForwardRef as ReactComponent };